import {
  IInvoiceData,
  IInvoice,
  IConsolidatedInvoiceData,
} from "../interfaces/IInvoice";
import {
  createListenerMiddleware,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import {
  createConsolidatedInvoiceAPI,
  getConsolidatedInvoicesApi,
  getInvoicesApi,
  updateInvoicesApi,
  generateInvoiceURLAPI,
  getInvoiceDetailsApi,
  getUnpaidConsolidatedInvoiceHeaders,
  generateConsolidatedInvoiceURLAPI,
  getConsolidatedInvoiceDetailsApi,
  getPaymentClearanceApi,
} from "src/api/invoicesAPI";
import { NUMBER_OF_ROWS_PER_PAGE } from "src/resources/constant";
import { handleResponse } from "src/services/apiServices";
import {
  convertDateIFNotMin,
  getCurrentDateTimeFormatted,
  isArabic,
  toCamel,
  toPascal,
} from "src/utils/helpers";
import { setPaymentDetails } from "./lookupSlice";
import { toast } from "react-toastify";

export const generateInvoiceURL = (invoiceId: any) => {
  return async (dispatch: any, getState: any) => {
    const {
      invoiceDetailsPopupData: { invoiceDetails },
    } = getState().invoices;
    dispatch(
      setPaymentDetails({
        invoiceId,
        paidAmount: invoiceDetails.totalAmountWithTax,
        paymentDateAndTime: getCurrentDateTimeFormatted(),
      })
    );
    return trackPromise(
      generateInvoiceURLAPI(invoiceId).then((response) => {
        if (response.data.RedirectInvoiceURL) {
          return response.data.RedirectInvoiceURL;
        }
        else {
          handleResponse(response);
          dispatch(getInvoiceDetails(invoiceId) as any);
          dispatch(getInvoices() as any);
          return null;
        }
        //dispatch(setInvoices({ data: mappedData, totalRecords }));
      })
    );
  };
};

export const generateConsolidatedInvoiceURL = (invoiceId: any) => {
  return async (dispatch: any, getState: any) => {
    const { consolidatedInvoiceDetailsPopupData } = getState().invoices;
    dispatch(
      setPaymentDetails({
        invoiceId: consolidatedInvoiceDetailsPopupData.consolidatedInvoiceId,
        paidAmount: consolidatedInvoiceDetailsPopupData.totalAmount,
        paymentDateAndTime: getCurrentDateTimeFormatted(),
      })
    );
    return trackPromise(
      generateConsolidatedInvoiceURLAPI(invoiceId).then((response) => {
        if (response.data.RedirectInvoiceURL) {
          return response.data.RedirectInvoiceURL;
        }
        else {
          handleResponse(response);
          dispatch(getConsolidatedInvoiceDetails(invoiceId) as any);
          dispatch(getConsolidatedInvoices() as any);
          return null;
        }
      })
    );
  };
};

export const getInvoices = () => {
  return async (dispatch: any, getState: any) => {
    // dispatch(setSelectedItems([]));

    const { invoices } = getState();
    const { filterData, gridCurrentPageInvoice, numberOfRowsPerPage } =
      invoices;
    const currentPage = gridCurrentPageInvoice + 1;
    const data = {
      ...toPascal({ ...filterData }),
      PagingOptions: {
        PageNumber: currentPage,
        PageSize: numberOfRowsPerPage,
      },
    };

    await trackPromise(
      getInvoicesApi(data).then((response) => {
        const invoicesData = toCamel(response?.data?.Invoices || []);
        const totalRecords = response.data?.PagingOptions.TotalRecordCount || 0;
        const mappedData = invoicesData.map((rec: IInvoiceData) => {
          return {
            ...rec,
            invoiceStatus: Number(rec.invoiceStatus.value),
            dueDate: convertDateIFNotMin(rec.dueDate),
          };
        });
        dispatch(setInvoices({ data: mappedData, totalRecords }));
      })
    );
  };
};
// export const payInvoice = (invoiceId: any) => {
//   return async (dispatch: any, getState: any) => {
//     await trackPromise(payInvoicesApi(invoiceId));
//   };
// };

export const createConsolidatedInvoice = () => {
  return async (dispatch: any, getState: any) => {
    const { invoices } = getState();
    const data = {
      InvoiceIds: invoices.selectedItems.map(
        (a: { invoiceId: any }) => a.invoiceId
      ),
    };
    return trackPromise(
      createConsolidatedInvoiceAPI(data)
        .then((response) => {
          dispatch(
            setConsolidatedInvoiceId(
              response.data?.ConsolidatedInvoice?.ConsolidatedInvoiceId
            )
          );
          const invoiceDetails = toCamel(response.data?.ConsolidatedInvoice);
          if (invoiceDetails) {
            const mappedData = {
              ...invoiceDetails,
              invoiceList: invoiceDetails?.invoiceList?.map((invoice: any) => {
                return {
                  ...invoice,
                  status: Number(invoice.invoiceStatus.value),
                  dueDate: convertDateIFNotMin(invoice.dueDate),
                };
              }),
            };
            dispatch(setConsolidatedInvoiceDetailsPopupData(mappedData));
          }
          return toCamel(response.data?.ConsolidatedInvoice || {});
        })
        .catch((error) => {
          handleResponse(error);
        })
    );
  };
};
export const updateConsolidatedInvoice = (
  isDelete = false,
  consolidatedInvoiceId = "",
  invoiceIds: string[] = []
) => {
  return async (dispatch: any, getState: any) => {
    return trackPromise(
      updateInvoicesApi(isDelete, consolidatedInvoiceId, invoiceIds)
    ).then((response) => {
      if (isDelete) {
        const { invoices } = getState();
        if (invoices.selectedItems?.length > 0) {
          const newSelectedItems = invoices.selectedItems.filter(
            (item: { invoiceId: string }) =>
              !invoiceIds.includes(item.invoiceId)
          );
          if (newSelectedItems.length === 0) {
            dispatch(resetConsolidatedInvoiceDetailsPopupData());
          } else {
            dispatch(
              getConsolidatedInvoiceDetails(consolidatedInvoiceId) as any
            );
          }
          dispatch(setSelectedItems(newSelectedItems));
        }
      } else {
        dispatch(setSelectedItems([]));
        dispatch(setIsAddToConsolidatedInvoicePopupOpen(false));
      }
      dispatch(getInvoices() as any);
      return response;
    });
  };
};

export const getConsolidatedInvoices = () => {
  return async (dispatch: any, getState: any) => {
    const { invoices } = getState();
    const {
      consolidatedFilterData,
      gridCurrentPageConsolidatedInvoice,
      numberOfRowsPerPage,
    } = invoices;

    const currentPage = gridCurrentPageConsolidatedInvoice + 1;

    const data = {
      ...consolidatedFilterData,
      PagingOptions: {
        PageNumber: currentPage,
        PageSize: numberOfRowsPerPage,
      },
    };
    return trackPromise(
      getConsolidatedInvoicesApi(data).then((response) => {
        const ConsolidatedInvoicesData = toCamel(
          response?.data?.ConsolidatedInvoices || []
        );
        const totalRecords = response.data?.PagingOptions.TotalRecordCount || 0;
        const mappedData = ConsolidatedInvoicesData.map(
          (rec: IConsolidatedInvoiceData) => {
            return {
              ...rec,
              status: Number(rec.status),
              invoiceList: rec.invoiceList.map((invoice) => {
                return {
                  ...invoice,
                  status: Number(invoice.invoiceStatus.value),
                  dueDate: convertDateIFNotMin(invoice.dueDate),
                };
              }),
            };
          }
        );
        dispatch(setConsolidatedInvoices({ data: mappedData, totalRecords }));
      })
    );
  };
};
export const getAllConsolidatedInvoices = () => {
  return async (dispatch: any, getState: any) => {
    return await trackPromise(getUnpaidConsolidatedInvoiceHeaders());
  };
};

export const getInvoiceDetails = (invoiceGuid: any) => {
  return async (dispatch: any, getState: any) => {
    trackPromise(
      getInvoiceDetailsApi(invoiceGuid).then((res) => {
        if (res.data) {
          const invoiceDetails = toCamel(res.data);
          dispatch(setInvoiceDetails(invoiceDetails));
          return invoiceDetails;
        }
      })
    );
  };
};

export const getConsolidatedInvoiceDetails = (invoiceGuid: any) => {
  return async (dispatch: any, getState: any) => {
    return trackPromise(
      getConsolidatedInvoiceDetailsApi(invoiceGuid).then((res) => {
        if (res.data) {
          const invoiceDetails = toCamel(res.data.ConsolidatedInvoice);
          if (invoiceDetails) {
            const mappedInvoiceList = invoiceDetails?.invoiceList?.map(
              (invoice: any) => {
                return {
                  ...invoice,
                  status: Number(invoice.invoiceStatus.value),
                  dueDate: convertDateIFNotMin(invoice.dueDate),
                };
              }
            );
            const mappedInvoiceData = {
              ...invoiceDetails,
              invoiceList: [...mappedInvoiceList],
            };
            dispatch(setConsolidatedInvoiceDetailsPopupData(mappedInvoiceData));
            if (invoiceDetails.invoiceList) {
              dispatch(setSelectedItems(mappedInvoiceList));
            }
          }
          return invoiceDetails;
        }
      })
    );
  };
};
export const getPaymentClearance = () => {
  return async (dispatch: any, getState: any) => {
    const language = getState().lookup.language;

    trackPromise(
      getPaymentClearanceApi()
        .then((res) => {
          if (res.data) {
            if (handleResponse(res, language)) {
              const paymentClearanceData = toCamel(res.data);
              const operationResponse = paymentClearanceData.operationResponse;
              if (
                paymentClearanceData &&
                !operationResponse.operationSucceeded
              ) {
                toast.error(
                  isArabic()
                    ? operationResponse?.errorDescriptionAr
                    : operationResponse?.errorDescriptionEn,
                  {
                    autoClose: 10000,
                  }
                );
              } else {
                dispatch(setPaymentClearanceData(paymentClearanceData));
                dispatch(setIsPaymentClearancePopupOpen(true));
              }
            }
          }
        })
        .catch((err) => {
          handleResponse(err);
        })
    );
  };
};

const initialState: IInvoice = {
  activeTab: 0,
  invoiceData: [],
  selectedItems: [],
  totalRowsCount: 0,
  totalConsolidatedRowsCount: 0,
  gridCurrentPageInvoice: 0,
  gridCurrentPageConsolidatedInvoice: 0,
  numberOfRowsPerPage: NUMBER_OF_ROWS_PER_PAGE,
  isConsolidatedInvoicePopupOpen: false,
  isAddToConsolidatedInvoicePopupOpen: false,
  isInvoicesDetailsPopupOpen: false,

  filterData: {
    paymentStatus: null,
    assignedBuildingId: null,
    propertyNumber: "",
    invoiceNumber: "",
    sortColumn: "dueDate",
    isAscending: true,
    showHistoricalData: false,
  },
  consolidatedFilterData: {
    paymentStatus: null,
    invoiceNumber: "",
    sortColumn: "consolidatedInvoiceNumber",
    isAscending: true,
    showHistoricalData: false,
  },
  invoiceDetailsPopupData: {
    invoiceDetails: {
      invoiceId: 0,
      invoiceNo: "",
      invoiceDueDate: "",
      propertyNo: "",
      paymentDate: "",
      installationFee: "",
      annualRegistrationFee: "",
      totalHassantukFee: "",
      additionalPaymentCharges: "",
      grandTotal: "",
    },
  },

  consolidatedInvoiceId: "",
  consolidatedInvoiceData: [],
  consolidatedInvoiceDetailsPopupData: {
    consolidatedInvoiceId: "",
    consolidatedInvoiceNo: "",
    consolidatedInvoiceNumber: "",
    consolidatedInvoiceName: "",
    invoiceDueDate: "",
    propertyNo: "",
    paymentDate: "",
    installationFee: "",
    annualRegistrationFee: "",
    totalHassantukFee: "",
    additionalPaymentCharges: "",
    totalAmount: 0,
    invoiceList: [],
  },
  isPaymentClearancePopupOpen: false,
  paymentClearanceData: {
    registrationDate: "",
    certificateIssueDate: "",
    companyName: "",
    tradeLicenseNumber: "",
    tradeLicenseExpiryDate: "",
    civilDefenseLicenseNo: "",
    civilDefenceLicenseExpiryDate: "",
    categoryOfLicense: 0,
    officeAddress: "",
    emirate: "",
    city: "",
    contactPersonName: "",
    designation: null,
    mobile: "",
    emailID: "",
    numberOfPropertiesRegistered: 0,
    companyBMCID: "",
  },
};

const invoiceSlice = createSlice({
  name: "invoices",
  initialState,
  reducers: {
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    setInvoices: (state, action) => {
      state.invoiceData = action.payload.data;
      state.totalRowsCount = action.payload.totalRecords;
    },
    setConsolidatedInvoices: (state, action) => {
      state.consolidatedInvoiceData = action.payload.data;
      state.totalConsolidatedRowsCount = action.payload.totalRecords;
    },
    setSelectedItems: (state, action) => {
      state.selectedItems = action.payload;
    },
    setConsolidatedInvoiceDetailsPopupData: (state, action): void => {
      state.consolidatedInvoiceDetailsPopupData = {
        ...state.consolidatedInvoiceDetailsPopupData,
        ...action.payload,
      };
    },
    resetConsolidatedInvoiceDetailsPopupData: (state) => {
      state.consolidatedInvoiceDetailsPopupData =
        initialState.consolidatedInvoiceDetailsPopupData;
    },
    setIsAddToConsolidatedInvoicePopupOpen: (state, action) => {
      state.isAddToConsolidatedInvoicePopupOpen = action.payload;
    },
    setIsInvoicesDetailsPopupOpen: (state, action) => {
      state.isInvoicesDetailsPopupOpen = action.payload;
    },
    setIsPaymentClearancePopupOpen: (state, action) => {
      state.isPaymentClearancePopupOpen = action.payload;
    },
    setGridCurrentPageInvoice: (state, action) => {
      state.gridCurrentPageInvoice = action.payload;
    },
    setGridCurrentPageConsolidatedInvoice: (state, action) => {
      state.gridCurrentPageConsolidatedInvoice = action.payload;
    },
    setTotalRowsCount: (state, action) => {
      state.totalRowsCount = action.payload;
    },
    clearInvoiceDetailsPopupData: (state) => {
      state.invoiceDetailsPopupData = initialState.invoiceDetailsPopupData;
    },
    setInvoicePopupData: (
      state,
      action: {
        payload: { field: string; value: string | number };
        type: string;
      }
    ): void => {
      state.invoiceDetailsPopupData = {
        ...state.invoiceDetailsPopupData,
        [action.payload.field]: action.payload.value,
      };
    },
    setFilterDataField: (state, action) => {
      state.filterData = {
        ...state.filterData,
        [action.payload.field]: action.payload.value,
      };
    },
    resetFilterData: (state) => {
      state.filterData = initialState.filterData;
      state.gridCurrentPageConsolidatedInvoice =
        initialState.gridCurrentPageConsolidatedInvoice;
      state.gridCurrentPageInvoice = initialState.gridCurrentPageInvoice;
    },
    setConsolidatedFilterDataField: (state, action) => {
      state.consolidatedFilterData = {
        ...state.consolidatedFilterData,
        [action.payload.field]: action.payload.value,
      };
    },
    resetConsolidatedFilterData: (state) => {
      state.consolidatedFilterData = initialState.consolidatedFilterData;
    },
    setNumberOfRowsPerPage: (state, action) => {
      state.numberOfRowsPerPage = action.payload;
    },
    setConsolidatedInvoiceId: (state, action) => {
      state.consolidatedInvoiceId = action.payload;
    },
    clearConsolidatedInvoiceId: (state) => {
      state.consolidatedInvoiceId = initialState.consolidatedInvoiceId;
    },
    setInvoiceDetails: (state, action) => {
      state.invoiceDetailsPopupData.invoiceDetails = action.payload;
    },
    setIsConsolidatedInvoicePopupOpen: (state, action) => {
      state.isConsolidatedInvoicePopupOpen = action.payload;
    },
    setPaymentClearanceData: (state, action) => {
      state.paymentClearanceData = action.payload;
    },
    clearPaymentClearanceData: (state) => {
      state.paymentClearanceData = initialState.paymentClearanceData;
    },
  },
});

export const {
  setActiveTab,
  setInvoices,
  setConsolidatedInvoices,
  setSelectedItems,
  setNumberOfRowsPerPage, //pagination
  setGridCurrentPageInvoice, //pagination
  setGridCurrentPageConsolidatedInvoice,
  setFilterDataField,
  resetFilterData,
  setConsolidatedFilterDataField,
  resetConsolidatedFilterData,
  setIsInvoicesDetailsPopupOpen,
  setConsolidatedInvoiceDetailsPopupData,
  setIsAddToConsolidatedInvoicePopupOpen,
  setConsolidatedInvoiceId,
  clearConsolidatedInvoiceId,
  setTotalRowsCount, //pagination
  clearInvoiceDetailsPopupData, //
  setInvoicePopupData, //
  setInvoiceDetails,
  resetConsolidatedInvoiceDetailsPopupData,
  setIsConsolidatedInvoicePopupOpen,
  setPaymentClearanceData,
  clearPaymentClearanceData,
  setIsPaymentClearancePopupOpen,
} = invoiceSlice.actions;
export default invoiceSlice.reducer;

const makeFilterInvoicesSelector = (dataSourceSelector: (state: any) => any) =>
  createSelector(
    dataSourceSelector,
    (state: any) => state.invoices.selectedItems,
    (invoiceData, selectedItems) => {
      return getInvoicesFilteredData(invoiceData, selectedItems);
    }
  );

export const selectInvoices = makeFilterInvoicesSelector(
  (state: any) => state.invoices.invoiceData
);

const makeFilterConsolidatedInvoicesSelector = (
  dataSourceSelector: (state: any) => any
) =>
  createSelector(
    dataSourceSelector,
    (state: any) => state.invoices.selectedItems,
    (invoiceData, selectedItems) => {
      return getConsolidatedInvoicesFilteredData(invoiceData, selectedItems);
    }
  );

export const selectConsolidatedInvoices =
  makeFilterConsolidatedInvoicesSelector(
    (state: any) => state.invoices.consolidatedInvoiceData
  );
//listener that listens to setGridCurrentPageInvoice and dispatch getPreventiveAppointment
const getInvoicesListenerMiddleware = createListenerMiddleware();

getInvoicesListenerMiddleware.startListening({
  actionCreator: setGridCurrentPageInvoice,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(getInvoices());
  },
});

export { getInvoicesListenerMiddleware };
function getInvoicesFilteredData(invoicesData: any, selectedItems: any): any {
  if (!invoicesData) return [];
  return invoicesData.filter((invoice: IInvoiceData) => {
    return Object.values(invoice).some((field) => {
      return field
        .toString()
        .toLowerCase()
        .includes(selectedItems.toLowerCase());
    });
  });
}

//listener that listens to setGridCurrentPageConsolidatedInvoice and dispatch getPreventiveAppointment
const getConsolidatedInvoicesListenerMiddleware = createListenerMiddleware();

getInvoicesListenerMiddleware.startListening({
  actionCreator: setGridCurrentPageConsolidatedInvoice,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(getConsolidatedInvoices());
  },
});

export { getConsolidatedInvoicesListenerMiddleware };
function getConsolidatedInvoicesFilteredData(
  invoicesData: any,
  selectedItems: any
): any {
  if (!invoicesData) return [];
  return invoicesData.filter((invoice: IInvoiceData) => {
    return Object.values(invoice).some((field) => {
      return field
        .toString()
        .toLowerCase()
        .includes(selectedItems.toLowerCase());
    });
  });
}
